import { portugueseMappings } from "~/components/search/Sort"
import { BrandPaginationProps } from "./BrandPaginationTop"
import Icon from "~/components/ui/Icon"
import stripTrackingParams from "~/sdk/stripTrackingParams"
import { SITE } from "~/constants"

const SORT_QUERY_PARAM = 'sort'

const applySort = (value: string, url: string) => {
  const urlFormatted = new URL(url ?? "/", SITE.URL)
  // Não repassar tracking/PII (utm_*, gclid, ?email=…) nos links de
  // ordenação (DECO-5819).
  const urlSearchParams = stripTrackingParams(new URLSearchParams(urlFormatted.search))

  urlSearchParams.set(SORT_QUERY_PARAM, value)
  urlFormatted.search = urlSearchParams.toString()

  // Relative href (path + search) — `.toString()` would carry the
  // https://www.miess.com.br base and send visitors to production.
  return urlFormatted.pathname + urlFormatted.search
}

export const BrandSort = ({ page, url, isMobile }: BrandPaginationProps) => {
  const sortOptions = page.sortOptions

  const filter = Object.entries(portugueseMappings)
    .filter(([key]) => sortOptions?.some((option) => option.label === key))
    .map(([value, label]) => ({
      value,
      label: portugueseMappings[label as keyof typeof portugueseMappings] ?? label,
    }))
    .filter(({ label }) => label)

  if (!filter?.length) return null

  return (
    <div
      className={`relative bg-white text-black border border-[#eee] cursor-pointer ${
        isMobile ? 'h-12 w-full mt-3 mb-4 px-4 py-[10px]' : 'w-[144px] px-2'
      }`}
    >
      <input id='ordenar-por' type='checkbox' className='fixed hidden peer' />
      <label
        className='h-[27px] w-full flex justify-between items-center text-xs cursor-pointer'
        htmlFor='ordenar-por'
      >
        <span>Ordenar por:</span>
        <Icon id='FilledChevronDown' size={7} />
      </label>

      <div className='absolute z-[2] top-full left-0 overflow-y-auto transition-all max-h-0 peer-checked:max-h-[400px] bg-white border border-neutral-200 w-full shadow-lg text-xs'>
        <ul className='flex flex-col py-3 tracking-tighter'>
          {filter.map(({ value, label }, i) => (
            <li key={`sort-${i}-${value}`}>
              <a className='px-2' href={applySort(value, url)}>
                <span className='text-sm'>{label}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
